/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderpickerCompany } from '../../models/orderpicker-company';
import { UpdateOrderpickerDto } from '../../models/update-orderpicker-dto';

export interface UpdateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params {
  id: number;
      body: UpdateOrderpickerDto
}

export function updateOneBaseMgmtOrderpickerControllerOrderpickerCompany(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerCompany>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtOrderpickerControllerOrderpickerCompany.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderpickerCompany>;
    })
  );
}

updateOneBaseMgmtOrderpickerControllerOrderpickerCompany.PATH = '/api/mgmt/orderpickers/{id}';
